import { DaysWeek } from '../../Menu/DaysWeek';
import { useTranslation } from 'react-i18next';
import { FormField } from '../../../components/FormField';
import Select from 'react-select';
import { timeOptions, timeToIso8601 } from '../../Menu/timeOptions';
import { PopOver } from '../../../components/PopOver';
import { CustomSelect } from '../../../components/Shared/CustomSelect';
import { cloneDeep } from 'lodash';
import { RoundedBox } from '../../../components/Shared/RoundedBox';

const STATUS_ENABLED = 'enabled';
const STATUS_DISABLED = 'disabled';

export const Hours = ({ formik }) => {
    const { t } = useTranslation();

    const times = formik.values.times;
    const daysWeek = [
        { title: t('Monday'), weekDay: 'monday' },
        { title: t('Tuesday'), weekDay: 'tuesday' },
        { title: t('Wednesday'), weekDay: 'wednesday' },
        { title: t('Thursday'), weekDay: 'thursday' },
        { title: t('Friday'), weekDay: 'friday' },
        { title: t('Saturday'), weekDay: 'saturday' },
        { title: t('Sunday'), weekDay: 'sunday' },
    ];

    const setValue = (value, weekDay, place) => {
        const newTimes = cloneDeep(times);
        newTimes[weekDay].status = STATUS_ENABLED;
        newTimes[weekDay][place] = value;
        formik.setFieldValue('times', newTimes);
    };

    const onActivateWeekday = (currentTime, weekDay) => {
        const newTimes = cloneDeep(times);

        if (currentTime) {
            newTimes[weekDay] = {
                ...newTimes[weekDay],
                status: currentTime.status === STATUS_DISABLED || !currentTime.status ? STATUS_ENABLED : STATUS_DISABLED,
            };
            formik.setFieldValue('times', newTimes);
        }
    };

    return (
        <RoundedBox>
            <div className="col-span-6 md:col-span-4 lg:col-span-3 pr-3">
                {daysWeek?.map(({ weekDay, title }) => {
                    const currentTime = times[weekDay];

                    const startTime = currentTime?.from ? { label: timeToIso8601(currentTime.from) } : null;
                    const endTime = currentTime?.to ? { label: timeToIso8601(currentTime.to) } : null;

                    const isTimeDisabled = currentTime?.status === STATUS_DISABLED || !currentTime?.status;

                    return (
                        <div className="flex items-center gap-8 mb-3.5" key={weekDay}>
                            <button
                                type="button"
                                onClick={() => onActivateWeekday(currentTime, weekDay)}
                                className={`w-[120px] h-[38px] mt-0.5 inline-flex justify-center items-center px-3 text-sm font-bold rounded-md hover:bg-purple-200 hover:text-black border-2 border-purple-500 shadow-sm ${
                                    isTimeDisabled ? 'bg-white' : 'bg-purple-500 text-white'
                                }`}
                            >
                                {title}
                            </button>

                            <FormField>
                                <CustomSelect
                                    options={timeOptions}
                                    value={startTime}
                                    name={`${weekDay}_start_time`}
                                    isDisabled={!currentTime || isTimeDisabled}
                                    onChange={({ value }) => setValue(value, weekDay, 'from')}
                                    placeholder={t('Select time')}
                                    isSearchable={false}
                                    className="h-9 w-[160px] self-start"
                                />
                            </FormField>
                            <FormField>
                                <CustomSelect
                                    options={timeOptions}
                                    name={`${weekDay}_end_time`}
                                    value={endTime}
                                    isDisabled={!currentTime || isTimeDisabled}
                                    onChange={({ value }) => setValue(value, weekDay, 'to')}
                                    placeholder={t('Select time')}
                                    isSearchable={false}
                                    className="h-9 w-[160px]"
                                />
                            </FormField>
                        </div>
                    );
                })}
            </div>
        </RoundedBox>
    );
};
